var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 860,
  height: 9,
  viewBox: "0 0 860 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1645_49525)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M688.397 4.79712L700.834 4.98093L700.814 6.73147L688.356 6.85401L688.397 4.79712Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M716.262 5.69862C721.518 5.45354 726.814 5.40102 732.11 5.52356L731.81 7.26536C726.754 7.05529 721.639 7.02028 716.543 7.16032L716.262 5.68986V5.69862Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M439.439 2.95898C447.122 3.11653 454.785 3.20406 462.489 3.21281L462.389 4.70953C454.725 4.51697 447.042 4.39443 439.358 4.35067L439.459 2.95898H439.439Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M483.333 3.60665L503.876 3.5979L503.836 5.32219L483.293 5.11212L483.333 3.60665Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M528.008 4.58716L548.551 4.63092V6.04887L528.008 6.09263V4.58716Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567.91 5.19092C575.252 5.47976 582.655 5.56729 590.037 5.44475L590.218 7.3791C582.655 7.5279 575.052 7.47538 567.509 7.20405L567.91 5.19092Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M614.432 5.10341C621.955 4.92835 629.518 4.90209 637.04 5.03338L636.9 6.66139C629.477 6.55636 622.055 6.60012 614.652 6.80144L614.432 5.09465V5.10341Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.62 4.98096L675.317 5.06848V6.58271L656.62 6.67023V4.98096Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M750.968 5.4624L771.51 5.50617V6.92411L750.968 6.96787V5.4624Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M790.87 6.06641C798.232 6.35525 805.615 6.44277 812.997 6.32024L813.178 8.25459C805.615 8.40339 798.012 8.35087 790.469 8.07954L790.87 6.06641Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M837.392 5.97865C844.915 5.8036 852.478 5.77734 860 5.90863L859.86 7.53664C852.437 7.4316 845.015 7.47537 837.612 7.67668L837.392 5.9699V5.97865Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.059 2.17139L261.497 2.35519L261.477 4.10574L249.019 4.22828L249.059 2.17139Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.924 3.07288C282.18 2.82781 287.476 2.77529 292.772 2.89783L292.471 4.63962C287.416 4.42956 282.3 4.39455 277.205 4.53459L276.924 3.06413V3.07288Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.100264 0.333252C7.78367 0.490801 15.447 0.578329 23.1505 0.587081L23.0502 2.0838C15.3868 1.89124 7.70343 1.7687 0.0200195 1.72494L0.120325 0.333252H0.100264Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.9937 0.980921L64.5363 0.972168L64.4962 2.69646L43.9536 2.48639L43.9937 0.980921Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.6699 1.96118L109.213 2.00495V3.42289L88.6699 3.46665V1.96118Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.572 2.56519C135.914 2.85403 143.317 2.94155 150.699 2.81901L150.88 4.75337C143.317 4.90217 135.713 4.84965 128.17 4.57831L128.572 2.56519Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.093 2.47767C182.616 2.30262 190.179 2.27636 197.702 2.40765L197.562 4.03566C190.139 3.93063 182.716 3.97439 175.314 4.1757L175.093 2.46892V2.47767Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.282 2.35522L235.979 2.44275V3.95697L217.282 4.0445V2.35522Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M311.63 2.83643L332.172 2.88019V4.29813L311.63 4.3419V2.83643Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M351.53 3.44043C358.893 3.72927 366.275 3.8168 373.658 3.69426L373.838 5.62861C366.275 5.77741 358.672 5.72489 351.129 5.45356L351.53 3.44043Z",
  fill: "#1B4191"
}), /*#__PURE__*/React.createElement("path", {
  d: "M398.052 3.35292C405.575 3.17786 413.138 3.15161 420.661 3.2829L420.521 4.91091C413.098 4.80587 405.675 4.84964 398.273 5.05095L398.052 3.34417V3.35292Z",
  fill: "#1B4191"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1645_49525"
}, /*#__PURE__*/React.createElement("rect", {
  width: 860,
  height: 8,
  fill: "white",
  transform: "translate(0 0.333252)"
})))));
export default SvgLine;